let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("4SS6F")).then(() => parcelRequire('f9lx5'));